/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import '@popperjs/core';
import './fontawesome';
import './swiper';
import './locomotive';
import { Tooltip } from 'bootstrap';

$(document).ready(() => {
  // console.log('Hello world');

  // add submenu toggler to menu-item with children
    jQuery('.menu-item-has-children > .nav-link').after('<div class="submenu-toggler"><svg xmlns="http://www.w3.org/2000/svg" width="18.456" height="11.314" viewBox="0 0 18.456 11.314"><g id="Group_1569" data-name="Group 1569" transform="translate(-116.737 -670.879)"><line id="Line_106" data-name="Line 106" x2="10" transform="translate(118.858 673) rotate(45)" fill="none" stroke="#00aa6f" stroke-linecap="round" stroke-width="3"/><line id="Line_107" data-name="Line 107" x2="10" transform="translate(133.071 673) rotate(135)" fill="none" stroke="#00aa6f" stroke-linecap="round" stroke-width="3"/></g></svg></div>');
    jQuery('.menu-item-has-children > .submenu-toggler').click(function() {
      jQuery(this).next().slideToggle();
      jQuery(this).parent().toggleClass('sub-menu--open');
    })
});

// var bt_chat = document.getElementById('btn_chat');
// if (bt_chat) {

//   bt_chat.addEventListener('click', function () {

//     var chat = document.getElementById('chat-widget-container');
//       if (chat.style.transform == 'scaleY(0)') {
//       chat.style.transform = 'scaleY(1)'
//     } else {
//       chat.style.transform = 'scaleY(0)'
//     }

//   }
//   );

// }

// var myTooltipEl = document.querySelector('#discountToolTip');
// if (myTooltipEl) {
//   var tooltip = new Tooltip(myTooltipEl);
// }

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl)
})
